import { createContext, useContext } from "react";
import type { ReactNode } from "react";

export interface ToolbarContextProps {
  theme?: "transparent" | "dark-buttons";
}

const ToolbarContext = createContext<ToolbarContextProps | null>(null);
ToolbarContext.displayName = "ToolbarContext";

export const useToolbarContext = (): ToolbarContextProps => {
  const context = useContext(ToolbarContext);

  if (!context) {
    throw new Error("useToolbarContext must be used within a Toolbar");
  }

  return context;
};

interface ToolbarProviderProps extends ToolbarContextProps {
  children: ReactNode;
}

export const ToolbarProvider = ({
  theme = "transparent",
  children,
}: ToolbarProviderProps) => (
  <ToolbarContext.Provider value={{ theme }}>
    {children}
  </ToolbarContext.Provider>
);

export { ToolbarContext };
